import { TableCell, TableRow, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import TableActions from "src/common/TableActions";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import type { IVisitorInvoiceList } from "../type/visitorType";

type IProps = {
	visitorInvoice: IVisitorInvoiceList;
	index: number;
	paginationSkip: number;
};

const VisitorInvoiceTableRow = ({
	visitorInvoice,
	index,
	paginationSkip,
}: IProps) => {
	const theme = useTheme();

	return (
		<TableRow hover>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{index + Number(paginationSkip)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{dayjs(visitorInvoice?.invoice_date).format("DD-MMM-YYYY")}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{visitorInvoice?.invoice_no}
				</Typography>
			</TableCell>

			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{" "}
					{visitorInvoice?.visitor_organization}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{`${visitorInvoice?.visitor_first_name} ${visitorInvoice?.visitor_last_name}`}{" "}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{visitorInvoice?.visitor_email}{" "}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{visitorInvoice?.net_total}{" "}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{visitorInvoice?.due}{" "}
				</Typography>
			</TableCell>
			<TableCell>
				{getStatusLabelInvoiceStatus(visitorInvoice?.status)}
			</TableCell>
			<TableActions
				showView
				viewLink={`/visitor/visitor-invoice/${visitorInvoice?.id}`}
			/>
		</TableRow>
	);
};

export default VisitorInvoiceTableRow;
